<div class="chart-container">

  @if (chartData && xLabels && lineChartData) {
    <div class="chart">
      <div class="phone-content">
        <canvas
          baseChart
          [data]="lineChartData"
          [options]="phoneChartOptions"
          [type]="'line'"
          >
        </canvas>
      </div>
      <div class="desktop-content">
        <canvas
          baseChart
          [data]="lineChartData"
          [options]="lineChartOptions"
          [type]="'line'"
          height="390px"
          width="680px"
          >
        </canvas>
      </div>
    </div>
  }
  <div class="custom-legend-container">
    <div class="custom-legend">
      @for (dataset of lineChartData!.datasets; track dataset) {
        <div class="legend-item">
          <div class="legend-item-line" [ngStyle]="{ 'backgroundColor': dataset.backgroundColor }"></div>
          <div class="legend-item-label" [ngStyle]="{ 'color': dataset.backgroundColor }">
            {{ dataset.label }}
          </div>
        </div>
      }
    </div>

    @if (previewVideo) {
      <div class="video-container" data-cy="develop-chart-video-container">
        <div class="video-with-desc">
          <div class="video-preview-container" data-cy="develop-chart-video">
            <libero-video-preview [videoPreview]="previewVideo"></libero-video-preview>
          </div>
          <p>{{ 'newPortfolio.videoButtonDesc' | translate }}</p>
        </div>
      </div>
    }
  </div>
</div>
